import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { useYupFields } from 'hooks/forms/useYupFields'

export const useCreateCustomerFeeSchema = (t: TFunction<'translation', undefined>) => {
  const { getRequiredYupField } = useYupFields()

  return yup.object({
    customerId: getRequiredYupField({
      label: t('customer'),
    }),
    payinsEnabled: yup.boolean().label(t('customers.feeSetup.payins')),
    payoutsEnabled: yup.boolean().label(t('customers.feeSetup.payouts')),
    currency: getRequiredYupField({
      label: t('currency'),
    }),
    feeStructure: getRequiredYupField({
      label: t('customers.feeSetup.feeStructure'),
    }),
    fixedFee: yup.string().label(t('customers.feeSetup.fixedFee')).optional(),
    percentageFee: yup.string().label(t('customers.feeSetup.percentageFee')).optional(),
  })
}
